import { useEffect, useRef, useState } from 'react'
import { useI18n } from '../i18n'
import { Toolbar } from '../components/Toolbar'
import { useBoard } from '../components/useBoard'
import { fileToDataURL, loadImage } from '../lib/img'
import { finishDrawing } from '../lib/flow'
import { useSession } from '../store/session'

export function Draw() {
  const { t } = useI18n()
  const s = useSession()
  const [count, setCount] = useState(0)
  const [photo, setPhoto] = useState(false)
  const [busy, setBusy] = useState(false)
  const fileRef = useRef<HTMLInputElement>(null)

  const { canvasRef, boardRef } = useBoard({ onChange: (st) => setCount(st.length) })

  // Возврат на холст («Продолжить рисунок») — восстанавливаем штрихи.
  useEffect(() => {
    const b = boardRef.current
    if (!b) return
    if (s.strokes.length && !b.strokes.length) {
      b.load(s.strokes)
      setCount(s.strokes.length)
    }
  }, [boardRef, s.strokes])

  const T = t.draw[s.mode]
  const doneLabel =
    s.mode === 'therapy' ? t.draw.doneTherapy : s.mode === 'reply' ? t.draw.doneReply : t.draw.doneFree

  const onPhoto = async (f: File) => {
    const url = await fileToDataURL(f)
    const img = await loadImage(url)
    boardRef.current?.setPhoto(img)
    setPhoto(true)
  }

  const done = async () => {
    const b = boardRef.current
    if (!b || busy) return
    setBusy(true)
    try {
      await finishDrawing(b.toDataURL(), b.strokes, b.hasPhoto())
    } finally {
      setBusy(false)
    }
  }

  return (
    <section className="screen">
      <h2>{T[0]}</h2>
      <p className="lead">{T[1]}</p>
      <div className="canvas-wrap">
        <canvas ref={canvasRef} className="board" />
      </div>
      <Toolbar
        onUndo={() => {
          boardRef.current?.undo()
          setCount(boardRef.current?.strokes.length ?? 0)
        }}
        onClear={() => {
          boardRef.current?.clear()
          setPhoto(false)
          setCount(0)
        }}
        onPhoto={s.mode !== 'reply' ? () => fileRef.current?.click() : undefined}
      />
      <p className="hint">{T[2]}</p>
      <input
        ref={fileRef}
        type="file"
        accept="image/*"
        capture="environment"
        hidden
        onChange={(e) => {
          const f = e.target.files?.[0]
          if (f) void onPhoto(f)
          e.target.value = ''
        }}
      />
      <div className="btn-row">
        <button className="btn btn-blue" disabled={(!count && !photo) || busy} onClick={done}>
          {doneLabel}
        </button>
      </div>
    </section>
  )
}
